import React, { useMemo } from 'react';
import RecentlyViewed from './RecentlyViewed';
import GoogleRelated from './GoogleRelated';
import { useShopifyProduct } from '../../../../api/shopify/ShopifyProduct';
import { ShopifyProductTransformer } from '../../../../api/shopify/ShopifyProductTransformer';
import { useSmartModuleContext } from '../SmartModuleProvider';

export type SmartModuleType = 'frequentlyBoughtTogether' | 'recommendedForYou' | 'recentlyViewed';

type SmartModuleWrapperProps = {
  title: string;
  type: SmartModuleType;
  location: string;
};

export const SmartModuleWrapper = ({ title, type, location }: SmartModuleWrapperProps) => {
  const { shopify, marketplaceSellers } = useShopifyProduct();
  const { smartModulesData } = useSmartModuleContext();

  const pdpBottomSmartModuleSettings = window.smartModuleSettings.pdpBottom;
  const isFBTBottomEnabled =
    pdpBottomSmartModuleSettings?.type === 'frequentlyBoughtTogether' && pdpBottomSmartModuleSettings?.isEnabled;

  const getButtonType = () => {
    if (isFBTBottomEnabled) return 'primary';
    if (type === 'frequentlyBoughtTogether') return 'secondary';
    return 'primary';
  };

  const applicableSettings = [
    window.smartModuleSettings.pdpBottom,
    window.smartModuleSettings.pdpMiddle,
    window.smartModuleSettings.pdpTop,
  ];

  const settings = applicableSettings.find(setting => setting?.type === type);

  const isMarketplaceProduct =
    ShopifyProductTransformer.isMarketplaceProduct({ product: shopify }) && !!marketplaceSellers?.[0];

  if (type === 'recentlyViewed')
    return <RecentlyViewed data={smartModulesData[`${type}AlgoliaData`]} settings={settings} />;

  if ((type === 'frequentlyBoughtTogether' || type === 'recommendedForYou') && isMarketplaceProduct) return null;

  return (
    <GoogleRelated
      data={smartModulesData[`${type}AlgoliaData`]}
      title={title}
      type={type}
      location={location}
      settings={settings}
      buttonType={getButtonType()}
    />
  );
};
